module.exports = __webpack_public_path__ + "static/media/cleanWorld.31234c80.jpg";